/* Buste & Aiguille — quiz d'orientation des articles.
   Lit la configuration JSON de l'attribut data-ba-quiz ; sans script, le tableau de repli reste affiché. */
(function () {
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text) n.textContent = text;
    return n;
  }

  function init(root) {
    var cfg;
    try { cfg = JSON.parse(root.getAttribute('data-ba-quiz')); } catch (e) { return; }
    if (!cfg || !cfg.questions || !cfg.questions.length) return;

    var zone = el('div', 'ba-quiz__zone');
    zone.setAttribute('aria-live', 'polite');
    root.insertBefore(zone, root.firstChild);
    root.classList.add('is-pret');
    var reponses = {};

    function resultat() {
      for (var i = 0; i < cfg.regles.length; i++) {
        var r = cfg.regles[i], ok = true;
        for (var k in r.si) if (reponses[k] !== r.si[k]) ok = false;
        if (ok) return cfg.resultats[r.alors];
      }
      return null;
    }

    function applicable(q) {
      if (!q.si) return true;
      for (var k in q.si) if (reponses[k] !== q.si[k]) return false;
      return true;
    }

    function afficher(index) {
      // Saute les questions qui ne concernent pas ce profil.
      while (index < cfg.questions.length && !applicable(cfg.questions[index])) index++;
      zone.innerHTML = '';
      zone.appendChild(el('p', 'ba-quiz__titre', cfg.titre));
      var res = index >= cfg.questions.length ? resultat() : null;

      if (res) {
        var bloc = el('div', 'ba-quiz__resultat');
        bloc.appendChild(el('p', 'ba-quiz__etape', 'Notre suggestion'));
        bloc.appendChild(el('p', 'ba-quiz__resultat-titre', res.titre));
        bloc.appendChild(el('p', '', res.texte));
        var actions = el('div', 'ba-quiz__actions');
        if (res.lien) {
          var a = el('a', 'ba-lien', res.ancre);
          a.href = res.lien;
          actions.appendChild(a);
        }
        var again = el('button', 'ba-quiz__recommencer', 'Recommencer');
        again.type = 'button';
        again.addEventListener('click', function () { reponses = {}; afficher(0); });
        actions.appendChild(again);
        bloc.appendChild(actions);
        zone.appendChild(bloc);
        return;
      }

      var q = cfg.questions[index];
      zone.appendChild(el('p', 'ba-quiz__etape', 'Question ' + (index + 1)));
      var label = el('p', 'ba-quiz__question', q.texte);
      label.id = 'ba-quiz-q-' + q.id;
      zone.appendChild(label);
      var choix = el('div', 'ba-quiz__choix');
      choix.setAttribute('role', 'group');
      choix.setAttribute('aria-labelledby', label.id);
      q.choix.forEach(function (c) {
        var b = el('button', '', c.t);
        b.type = 'button';
        b.addEventListener('click', function () {
          reponses[q.id] = c.v;
          afficher(index + 1);
          var first = zone.querySelector('button, a');
          if (first) first.focus({ preventScroll: true });
        });
        choix.appendChild(b);
      });
      zone.appendChild(choix);
    }

    afficher(0);
  }

  function start() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-ba-quiz]'), init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
